import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../macroscopia.action';
import * as commonActions from '../../../../../../app/common/common.action';
import GeracaoBlocosPage from './gerar-blocos.page';
import { getUsuarioLocalStorage } from '../../../../../../localStorage.util';
import { acessoPermitido } from '../../../../../../acessos.seguranca';
import * as acessos from '../../../../../../acessos.const.util';
import WebapiCommon from '../../../../../../app/common/util/webapi.common';
import * as DefaultValues from '../../../../../../app/common/util/defaultValues';

const tiposDescarte = DefaultValues.tipoDescarteOptions.filter(
	x => x.value !== DefaultValues.tipoDescarteEmum.SEPULTAMENTO_INDIVIDUAL
);

class GeracaoBlocosContainer extends Component {
	constructor(props) {
		super(props);
		this.createRefs();
		this.UsuarioLocalStorage = getUsuarioLocalStorage();
		this.state = {
			frasco: [],
			numeroBlocos: null,
			numeroFragmentos: null,
			material: null,
			tipoBloco: null,
			medico: null,
			tecnico: null,
			sentinelaMama: false,
			sentinelaMelanoma: false,
			anotacoes: undefined,
			activeTab:
				acessoPermitido(props.usuario, acessos.Cassetes) &&
					acessoPermitido(props.usuario, acessos.AdicionarBlocos) &&
					!props.macroscopiaFinalizada
					? '1'
					: '2',
			showDetalhesBloco: false,
			detalhesBloco: undefined,
			modoEdicao: false,
			justificativaCancelamento: '',
			justificativaCancelamentoIsInvalid: false,
			showModalCancelamento: false,
			novoscortes: false,
			coloracao: false,
			antigeno: false,
			variosFragmentos: false,
			agrupamento: [],
			coloracoesSelecionadas: [],
			antigenosSelecionados: [],
			complementoAgrupamento: undefined,
			cassetesNumeracaoContinua: false,
			alturaModal: '600px',
			modalControleReceptaculo: false,
			urgente: false,
			materialTotalmenteSubmetido: false,
			showModalJustificativaReabertura: false,
			textoJustificativaReabertura: '',
			tipoDescarteOptions: tiposDescarte,
			tipoDescarte: tiposDescarte.find(
				x => x.value === DefaultValues.tipoDescarteEmum.PADRAO
			),
			medicoTipoDescarte: null
		};
	}

	createRefs() {
		this.frascoRef = React.createRef();
		this.numeroBlocosRef = React.createRef();
		this.numeroFragmentosRef = React.createRef();
		this.materialRef = React.createRef();
		this.coloracaoRef = React.createRef();
		this.antigenoRef = React.createRef();
		this.checkColoracaoRef = React.createRef();
		this.checkAntigenoRef = React.createRef();
		this.checkNovoCorteRef = React.createRef();
		this.checkVariosFragRef = React.createRef();
		this.tipoBlocoRef = React.createRef();
		this.tecnicoRef = React.createRef();
		this.medicoRef = React.createRef();
		this.anotacaoRef = React.createRef();
		this.tipoDescarteRef = React.createRef();
		this.medicoTipoDescarteRef = React.createRef();
	}

	render() {
		return (
			<GeracaoBlocosPage
				usuario={this.props.usuario}
				frascos={this.props.frascos}
				materiais={this.props.material}
				tipos={this.props.tipo}
				frasco={this.state.frasco}
				material={this.state.material}
				tipo={this.props.tipo}
				finalizarMapa={this.finalizarMapa.bind(this)}
				reabrirMapa={this.reabrirMapa.bind(this)}
				tipoBloco={this.state.tipoBloco}
				variosFragmentos={this.state.variosFragmentos}
				sentinelaMama={this.state.sentinelaMama}
				sentinelaMelanoma={this.state.sentinelaMelanoma}
				novoscortes={this.state.novoscortes}
				coloracao={this.state.coloracao}
				coloracoes={this.props.coloracoes}
				coloracoesEdicao={this.props.coloracoes}
				coloracoesSelecionadas={this.state.coloracoesSelecionadas}
				antigeno={this.state.antigeno}
				antigenos={this.props.antigenos}
				antigenosSelecionados={this.state.antigenosSelecionados}
				antigenosEdicao={this.props.antigenos}
				anotacoes={this.state.anotacoes}
				numeroFragmentos={this.state.numeroFragmentos}
				numeroBlocos={this.state.numeroBlocos}
				medico={this.state.medico}
				tecnico={this.state.tecnico}
				medicoMacro={this.props.medicoMacroscopista}
				medicoTecnico={this.props.medicoTecnico}
				blocos={this.props.blocos}
				blocosExistentes={this.props.blocosExistentes}
				updateValorState={this.updateValorState.bind(this)}
				adicionarBloco={this.adicionarBloco.bind(this)}
				gravarBloco={this.gravarBloco.bind(this)}
				toggle={this.toggle.bind(this)}
				activeTab={this.state.activeTab}
				getTabIndex={this.getTabIndex.bind(this)}
				showDetalhesBloco={this.state.showDetalhesBloco}
				setVisibilidadeDetalhes={this.setVisibilidadeDetalhes.bind(this)}
				setInitialStateBlocoCadstro={this.setInitialStateBlocoCadstro.bind(
					this
				)}
				detalhesBloco={this.state.detalhesBloco}
				modoEdicao={this.state.modoEdicao}
				alternarModoEdicao={this.alternarModoEdicao.bind(this)}
				updateValorDetalhesState={this.updateValorDetalhesState.bind(this)}
				updateValorColoracaoDetalhes={this.updateValorColoracaoDetalhes.bind(
					this
				)}
				updateValorAntigenoDetalhes={this.updateValorAntigenoDetalhes.bind(
					this
				)}
				updateDetalhes={this.updateDetalhes.bind(this)}
				onChangeJustificativaCancelamento={this.onChangeJustificativaCancelamento.bind(
					this
				)}
				acessoPermitido={acessoPermitido}
				agrupamento={this.state.agrupamento}
				adicionarCasseteParaAgrupamento={this.adicionarCasseteParaAgrupamento.bind(
					this
				)}
				removerCasseteParaAgrupamento={this.removerCasseteParaAgrupamento.bind(
					this
				)}
				complementoAgrupamento={this.state.complementoAgrupamento}
				gerarLabelColoracao={this.gerarLabelColoracao.bind(this)}
				gerarLabelAntigeno={this.gerarLabelAntigeno.bind(this)}
				onChangeComplementoAgrupamento={this.onChangeComplementoAgrupamento.bind(
					this
				)}
				agruparCasseteSelecionado={this.agruparCasseteSelecionado.bind(this)}
				alturaModal={this.state.alturaModal}
				macroscopiaFinalizada={this.props.macroscopiaFinalizada}
				mapaFinalizado={this.props.detalhes.mapaFinalizado}
				exameFinalizado={this.props.exameFinalizado}
				frascoRef={this.frascoRef}
				coloracaoRef={this.coloracaoRef}
				antigenoRef={this.antigenoRef}
				numeroBlocosRef={this.numeroBlocosRef}
				numeroFragmentosRef={this.numeroFragmentosRef}
				materialRef={this.materialRef}
				tipoBlocoRef={this.tipoBlocoRef}
				tecnicoRef={this.tecnicoRef}
				medicoRef={this.medicoRef}
				anotacaoRef={this.anotacaoRef}
				checkColoracaoRef={this.checkColoracaoRef}
				checkAntigenoRef={this.checkAntigenoRef}
				checkVariosFragRef={this.checkVariosFragRef}
				checkNovoCorteRef={this.checkNovoCorteRef}
				setFocusProximoCampo={this.setFocusProximoCampo}
				updateValorSentinela={this.updateValorSentinela.bind(this)}
				updateValorSentinelaModoEdicao={this.updateValorSentinelaModoEdicao.bind(
					this
				)}
				cassetesNumeracaoContinua={this.state.cassetesNumeracaoContinua}
				modalControleReceptaculo={this.state.modalControleReceptaculo}
				toogleModalControleReceptaculo={this.toogleModalControleReceptaculo.bind(
					this
				)}
				laudo={this.props.detalhes.laudo}
				commonActions={this.props.commonActions}
				urgente={this.state.urgente}
				materialTotalmenteSubmetido={this.state.materialTotalmenteSubmetido}
				marcarMaterialSubmetido={this.marcarMaterialSubmetido.bind(this)}
				editarMaterialSubmetido={this.editarMaterialSubmetido.bind(this)}
				habilitarBotaoAdicionar={this.habilitarBotaoAdicionar.bind(this)}
				exameEntregue={this.props.detalhes.entregue}
				cancelarBloco={this.cancelarBloco.bind(this)}
				justificativaCancelamento={this.state.justificativaCancelamento}
				justificativaCancelamentoIsInvalid={
					this.state.justificativaCancelamentoIsInvalid
				}
				obterNumeroBloco={this.obterNumeroBloco.bind(this)}
				showModalJustificativaReabertura={
					this.state.showModalJustificativaReabertura
				}
				toogleModalJustificativaReabertura={this.toogleModalJustificativaReabertura.bind(
					this
				)}
				textoJustificativaReabertura={this.state.textoJustificativaReabertura}
				changeTextoJustificativaReabertura={this.changeTextoJustificativaReabertura.bind(
					this
				)}
				apagarCassetesEReordenar={this.apagarCassetesEReordenar.bind(this)}
				numeroFragmentosKeyPress={this.numeroFragmentosKeyPress.bind(this)}
				tipoDescarte={this.state.tipoDescarte}
				tipoDescarteRef={this.tipoDescarteRef}
				tipoDescarteOptions={this.state.tipoDescarteOptions}
				medicoTipoDescarte={this.state.medicoTipoDescarte}
				medicoTipoDescarteRef={this.medicoTipoDescarteRef}
				showModalCancelamento={this.state.showModalCancelamento}
				toggleModalCancelamento={this.toggleModalCancelamento.bind(this)}
				handleCreateSelectCreatable={this.handleCreateSelectCreatable.bind(
					this
				)}
				fecharModal={this.props.fecharModal}
			/>
		);
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.activeTab !== this.state.activeTab &&
			this.state.activeTab === '1'
		) {
			this.frascoRef && this.frascoRef.current.focus();
		}
	}

	handleCreateSelectCreatable = value => {
		this.props.commonActions.showFadeCarregando(true);
		WebapiCommon.cadastrarMateriais(value).then(() => {
			WebapiCommon.getMaterial().then(res => {
				this.props.actions.preencherSelectMaterial(res);
				let state = { ...this.state };
				state.material = res.find(el => el.label.includes(value.toUpperCase()));
				this.setState(state);
				this.props.commonActions.showFadeCarregando(false);
			});
		});
	};

	getTabIndex(name) {
		var tabIndex = {
			frasco: 1,
			numeroBlocos: 2,
			numeroFragmentos: 3,
			checkVariosFragmentos: 4,
			checkNovosCortes: 5,
			checkColoracao: 6,
			checkAntigeno: 7,
			coloracoesSelecionadas: -1,
			antigenosSelecionados: -1,
			material: 8,
			tipoBloco: 9,
			tecnico: 10,
			medico: 11,
			anotacoes: 12,
			adicionarCassete: 13
		};

		if (this.state.coloracao) {
			tabIndex.coloracoesSelecionadas = 8;
			tabIndex.material += 1;
			tabIndex.tipoBloco += 1;
			tabIndex.tecnico += 1;
			tabIndex.medicos += 1;
			tabIndex.anotacoes += 1;
			tabIndex.adicionarCassete += 1;
		}

		if (this.state.antigeno) {
			tabIndex.antigenosSelecionados = this.state.checkColoracao ? 9 : 8;
			tabIndex.material += 1;
			tabIndex.tipoBloco += 1;
			tabIndex.tecnico += 1;
			tabIndex.medicos += 1;
			tabIndex.anotacoes += 1;
			tabIndex.adicionarCassete += 1;
		}

		return tabIndex[name];
	}

	componentWillUnmount() {
		this.props.actions.adicionarBlocosTemporarios([]);
		this.props.actions.adicionarBloco([]);
	}

	async componentDidMount() {
		this.props.actions.showFadeCarregando(true);
		var requests = [
			await WebapiCommon.getFrascos(this.props.detalhes.laudo),
			await WebapiCommon.getBlocos(this.props.detalhes.laudo),
			await WebapiCommon.getConfiguracaoMapaMacroscopico()
		];

		var index = 3;
		var indexRequest = {
			materiais: null,
			tipos: null,
			medicos: null,
			usuarios: null,
			coloracoes: null,
			antigenos: null
		};
		if (this.props.material && this.props.material.length === 0) {
			requests.push(await WebapiCommon.getMaterial());
			indexRequest.materiais = index;
			index += 1;
		}
		if (this.props.tipo && this.props.tipo.length === 0) {
			requests.push(WebapiCommon.getTipo(this.props.intl));
			indexRequest.tipos = index;
			index += 1;
		}
		if (
			this.props.medicoMacroscopista &&
			this.props.medicoMacroscopista.length === 0
		) {
			requests.push(await WebapiCommon.getMedicos());
			indexRequest.medicos = index;
			index += 1;
		} else {
			this.preencherMedicoMacroscopistaPadrao(this.props.medicoMacroscopista);
		}
		if (this.props.medicoTecnico && this.props.medicoTecnico.length === 0) {
			requests.push(await WebapiCommon.obterUsuarios());
			indexRequest.usuarios = index;
			index += 1;
		} else {
			this.preencherTecnicoMacroscopistaPadrao(this.props.medicoTecnico);
		}

		if (this.props.coloracoes && this.props.coloracoes.length === 0) {
			requests.push(await WebapiCommon.getColoracoes());
			indexRequest.coloracoes = index;
			index += 1;
		}
		if (this.props.antigenos && this.props.antigenos.length === 0) {
			requests.push(await WebapiCommon.getAntigenos());
			indexRequest.antigenos = index;
			index += 1;
		}

		Promise.all(requests).then(response => {
			this.props.actions.preencherFrascos(
				response[0]
					.filter(el => el.status !== 'CANCELADO')
					.map(frasco => ({ value: frasco.frascoId, label: frasco.dsFrasco }))
			);

			if (response[0].length === 0) {
				this.props.commonActions.showAlerta(
					'alerta',
					`${this.props.intl.formatMessage({ id: 'dashboards.disposalMaterials.table.nobottle' })}`,
					2500
				);
			}

			this.props.actions.adicionarBlocosExistentes(response[1]);
			this.setState({
				cassetesNumeracaoContinua: response[2].configuracoesMapaMacroscopicoItems.find(
					el => el.coluna === 'Sn_Cassete_Bloco_Continuo'
				).valor,
				urgente: !!this.props.detalhes && this.props.detalhes.urgente
			});

			if (indexRequest.materiais)
				this.props.actions.preencherSelectMaterial(
					response[indexRequest.materiais]
				);
			if (indexRequest.tipos)
				this.props.actions.preencherSelectTipo(response[indexRequest.tipos]);
			if (indexRequest.medicos) {
				this.props.actions.preencherSelectMedicoMacro(
					response[indexRequest.medicos]
				);
				this.preencherMedicoMacroscopistaPadrao(response[indexRequest.medicos]);
			} else {
				this.preencherMedicoMacroscopistaPadrao(this.props.medicoMacroscopista);
			}
			if (indexRequest.usuarios) {
				this.props.actions.preencherSelectMedicoTecnico(
					response[indexRequest.usuarios]
				);
				this.preencherTecnicoMacroscopistaPadrao(
					response[indexRequest.usuarios]
				);
			}
			if (indexRequest.coloracoes)
				this.props.commonActions.preencherSelectColoracao(
					response[indexRequest.coloracoes]
				);
			if (indexRequest.antigenos)
				this.props.commonActions.preencherSelectAntigenos(
					response[indexRequest.antigenos]
				);

			this.props.actions.showFadeCarregando(false);
			if (this.frascoRef && this.frascoRef.current)
				this.frascoRef.current.focus();
		});
	}

	habilitarBotaoAdicionar() {
		return (
			this.props.detalhes.mapaFinalizado ||
			!this.state.tecnico ||
			!this.state.tipoBloco ||
			!this.state.material ||
			!this.state.frasco.length > 0 ||
			!this.state.numeroBlocos ||
			!(
				!this.state.coloracao ||
				(this.state.coloracao && this.state.coloracoesSelecionadas.length > 0)
			) ||
			!(this.state.variosFragmentos || this.state.numeroFragmentos > 0) ||
			!(
				!this.state.antigeno ||
				(this.state.antigeno && this.state.antigenosSelecionados.length > 0)
			)
		);
	}
	preencherMedicoMacroscopistaPadrao(medicos) {
		if (this.props.detalhes.medMacro) {
			let medicoPadrao = medicos.find(
				el => el.value === Number(this.props.detalhes.medMacro)
			);
			if (medicoPadrao) {
				this.setState({
					medico: medicoPadrao,
					medicoTipoDescarte: medicoPadrao
				});
			}
		}
	}

	preencherTecnicoMacroscopistaPadrao(tecnicos) {
		const usuarioLocalStorage = getUsuarioLocalStorage();

		if (usuarioLocalStorage.usuarioId) {
			const tecnico = tecnicos.find(
				el => el.value === Number(usuarioLocalStorage.usuarioId)
			);
			if (tecnico) {
				this.setState({ tecnico });
			}
		}
	}

	finalizarMapa() {
		this.props.actions.showFadeCarregando(true);
		WebapiCommon.finalizarReabrirMapa(
			this.props.detalhes.laudo,
			false,
			''
		).then(result => {
			this.props.actions.showFadeCarregando(false);
			this.atualizarStatusMapa(true);
			this.operacaoAlertaSucesso();
			if (this.props.imprimirControleCassetesAoFinalizarMapa) {
				this.toogleModalControleReceptaculo();
			} else {
				this.props.actions.visibilidadeModalMapaMacroscopico(false);
			}
		});
	}

	reabrirMapa() {
		let { textoJustificativaReabertura } = this.state;
		this.props.actions.showFadeCarregando(true);
		WebapiCommon.finalizarReabrirMapa(
			this.props.detalhes.laudo,
			true,
			textoJustificativaReabertura
		).then(result => {
			this.props.actions.showFadeCarregando(false);
			this.operacaoAlertaSucesso();
			this.atualizarStatusMapa(false);
			this.toogleModalJustificativaReabertura();

			if (result.existeLamina) {
				this.props.commonActions.showAlerta(
					'alerta',
					'Existem lâminas vinculadas a esse exame',
					3000
				);
			}
		});
	}

	atualizarStatusMapa(finalizado) {
		let detalhes = this.props.detalhes;
		detalhes.mapaFinalizado = finalizado;
		this.props.commonActions.atualizarDetalhes(detalhes);
		this.forceUpdate();
	}

	alternarModoEdicao() {
		this.setState({
			modoEdicao: !this.state.modoEdicao
		});
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	toggleModalCancelamento() {
		this.onChangeJustificativaCancelamento('');
		this.setState({
			showModalCancelamento: !this.state.showModalCancelamento
		});
	}

	cancelarBloco(bloco) {
		this.toggleModalCancelamento();
		this.props.actions.showFadeCarregando(true);
		WebapiCommon.getDetalhesBlocos(bloco.laudo, bloco.id).then(
			detalhesBloco => {
				this.props.actions.showFadeCarregando(false);
				this.setState({
					detalhesBloco
				});
			}
		);
	}

	setInitialStateBlocoCadstro() {
		if (this.state.showDetalhesBloco) {
			this.setState({
				detalhesBloco: undefined,
				showDetalhesBloco: !this.state.showDetalhesBloco,
				tipoDescarte: tiposDescarte.find(
					x => x.value === DefaultValues.tipoDescarteEmum.PADRAO
				)
			});
			this.preencherMedicoMacroscopistaPadrao(this.props.medicoMacroscopista);
		}
	}

	setVisibilidadeDetalhes(laudobloco) {
		this.props.actions.showFadeCarregando(true);
		if (!this.state.showDetalhesBloco) {
			WebapiCommon.getDetalhesBlocos(
				this.props.detalhes.laudo,
				laudobloco
			).then(detalhesBloco => {
				this.props.actions.showFadeCarregando(false);

				if (detalhesBloco.coloracao) {
					var options = this.props.coloracoes[1].options;
					var coloracoes = [];

					detalhesBloco.coloracoesId.forEach(c => {
						coloracoes = coloracoes.concat(options.filter(o => c === o.id));
					});

					detalhesBloco.coloracoesId = coloracoes;
				}

				if (detalhesBloco.antigeno) {
					var antigenos = [];
					detalhesBloco.antigenosId.forEach(at => {
						antigenos.push(this.props.antigenos.find(a => a.value === at));
					});

					detalhesBloco.antigenosId = antigenos;
				}

				this.setState({
					showDetalhesBloco: !this.state.showDetalhesBloco,
					detalhesBloco: detalhesBloco,
					justificativaCancelamentoIsInvalid: false,
					tipoDescarte: !detalhesBloco.tipoDescarte
						? tiposDescarte.find(
							x => x.value === DefaultValues.tipoDescarteEmum.PADRAO
						)
						: tiposDescarte.find(x => x.value === detalhesBloco.tipoDescarte),
					medicoTipoDescarte: detalhesBloco.medicoTipoDescarteId
						? this.props.medicoMacroscopista.find(
							m =>
								Number(m.value) === Number(detalhesBloco.medicoTipoDescarteId)
						)
						: null
				});
			});
		} else {
			WebapiCommon.getBlocos(this.props.detalhes.laudo).then(blocos => {
				this.props.actions.adicionarBlocosExistentes(blocos);
				this.props.actions.showFadeCarregando(false);
				this.ocultarComAtraso();
				this.setState({
					showDetalhesBloco: !this.state.showDetalhesBloco
				});
			});
		}
	}

	updateDetalhes(laudobloco, procedimentoId, exameId, tipoId) {
		const usuarioLocalStorage = getUsuarioLocalStorage();
		const blocos = {
			UsuarioLogado: usuarioLocalStorage.usuarioId,
			UsuarioNome: usuarioLocalStorage.usuario,
			NrExame: this.props.detalhes.nrExame,
			CdMaterial:
				this.state.detalhesBloco.material !== undefined
					? this.state.detalhesBloco.material
					: this.state.detalhesBloco.materialId,
			TipoBloco: this.state.detalhesBloco.tipoBloco,
			Observacao:
				this.state.detalhesBloco.anotacoes !== undefined
					? this.state.detalhesBloco.anotacoes
					: '',
			IdTecnico: this.state.detalhesBloco.tecnicoId,
			Coloracao: !!this.state.detalhesBloco.coloracoesId.length
				? true
				: this.state.detalhesBloco.coloracao,
			ColoracoesId: this.state.detalhesBloco.coloracoesId.map(c => c.id),
			Antigeno: this.state.detalhesBloco.antigenosId.length
				? true
				: this.state.detalhesBloco.antigeno,
			AntigenosId: this.state.detalhesBloco.antigenosId.map(a => a.value),
			CdMedico: this.state.detalhesBloco.medicoId,
			SentinelaMama: this.state.detalhesBloco.sentinelaMama,
			SentinelaMelanoma: this.state.detalhesBloco.sentinelaMelanoma,
			materialTotalmenteSubmetido: this.state.detalhesBloco
				.materialTotalmenteSubmetido,
			ProcedimentoId: procedimentoId,
			ExameId: exameId,
			TipoId: tipoId,
			tipoDescarte: this.state.tipoDescarte
				? this.state.tipoDescarte.value
				: null,
			medicoTipoDescarteId: this.state.medicoTipoDescarte
				? this.state.medicoTipoDescarte.value
				: null
		};

		if (
			!blocos.materialTotalmenteSubmetido &&
			blocos.tipoDescarte &&
			!blocos.medicoTipoDescarteId
		) {
			this.props.commonActions.showAlerta(
				'erro',
				'Com a opção de descarte selecionada é necessário informar o médico solicitante do mesmo.',
				5000,
				'750px'
			);
			return;
		}
		this.props.actions.showFadeCarregando(true);
		WebapiCommon.atualizarBlocos(
			this.props.detalhes.laudo,
			laudobloco,
			blocos
		).then(() => {
			this.operacaoAlertaSucesso();
			this.setVisibilidadeDetalhes(laudobloco);
		});
	}

	apagarCassetesEReordenar = (
		idlaudobloco,
		frasco,
		isNovoCorte,
		isDoisFrascosUmCassete,
		procedimentoId,
		exameId,
		tipoId,
		nrBloco
	) => {
		this.props.actions.showFadeCarregando(true);

		let blocoASerCancelado = {
			UsuarioLogado: this.UsuarioLocalStorage.usuarioId,
			UsuarioNome: this.UsuarioLocalStorage.usuario,
			NrExame: this.props.detalhes.nrExame,
			Motivo: this.state.justificativaCancelamento,
			ProcedimentoId: procedimentoId,
			ExameId: exameId,
			TipoId: tipoId,
			NrBloco: nrBloco,
			NovoBloco: isNovoCorte,
			DoisFrascos: isDoisFrascosUmCassete
		};

		if (blocoASerCancelado.Motivo.length > 100) {
			this.props.actions.showFadeCarregando(false);
			return this.props.commonActions.showAlerta(
				'erro',
				'Não é possível prosseguir, número de caracteres no campo justificativa é superior a 100.',
				7000,
				'750px'
			);
		}

		WebapiCommon.apagarCasseteEReordenar(
			idlaudobloco,
			this.props.detalhes.laudo,
			frasco,
			blocoASerCancelado
		)
			.then(() => {
				this.props.actions.showFadeCarregando(false);
				this.toggleModalCancelamento();
				this.operacaoAlertaSucesso();
				const blocosUpdated = this.props.blocosExistentes.map(bloco => ({
					...bloco,
					cancelado: bloco.id === idlaudobloco ? true : bloco.cancelado
				}));
				this.props.actions.adicionarBlocosExistentes(blocosUpdated);
			})
			.catch(() => this.toggleModalCancelamento());
	};

	ocultarComAtraso() {
		setTimeout(() => {
			this.setState({
				detalhesBloco: undefined,
				justificativaCancelamento: '',
				modoEdicao: false
			});
		}, 500);
	}

	updateValorState(name, value) {
		let state = { ...this.state };
		if (name === 'coloracoesSelecionadas') {
			let coloracoes = [];
			value.forEach(color => {
				if (color.coloracoes) {
					color.coloracoes.forEach(c => {
						coloracoes.push(c);
					});
				} else {
					coloracoes.push(color);
				}
			});
			coloracoes = Array.from(new Set(coloracoes.map(JSON.stringify))).map(
				JSON.parse
			);
			state.coloracoesSelecionadas = coloracoes;
			this.setState(state);
		} else if (name === 'frasco' && !value) {
			state.frasco = '';
			this.setState(state);
		} else if (name !== 'frasco' || (name === 'frasco' && value.length <= 2)) {
			state[name] = value;
			this.setState(state);
		}

		this.adicionarBloco(state);
		this.setFocusProximoCampo(name, value);
	}

	adicionarBloco(state) {
		let {
			frasco,
			numeroBlocos,
			numeroFragmentos,
			variosFragmentos,
			material,
			novoscortes
		} = state;

		numeroFragmentos = variosFragmentos ? '0' : numeroFragmentos;

		const camposObrigatoriosPreenchidos =
			frasco !== null &&
			frasco.length > 0 &&
			!!numeroBlocos &&
			!!numeroFragmentos &&
			material !== null;

		if (camposObrigatoriosPreenchidos) {
			let blocos = [];
			blocos.push({
				frascoId: frasco.map(f => f.value),
				cassetes: numeroBlocos,
				fragmentos: numeroFragmentos,
				materialId: material.value,
				novosCortes: novoscortes
			});

			this.props.actions.adicionarBlocosTemporarios(blocos);

			WebapiCommon.gerarBlocos(this.props.detalhes.laudo, blocos).then(
				bloco => {
					this.props.actions.adicionarBloco(bloco);
				}
			);
		} else {
			const existeCasseteTemporario = this.props.blocosNovos.length > 0;

			if (existeCasseteTemporario) {
				this.props.actions.adicionarBlocosTemporarios([]);
				this.props.actions.adicionarBloco([]);
			}
		}
	}

	setFocusProximoCampo(name, value) {
		switch (name) {
			case 'frasco':
				this.numeroBlocosRef.current.focus();
				break;
			case 'numeroBlocos':
				this.numeroFragmentosRef.current.focus();
				break;
			case 'numeroFragmentos':
				this.checkVariosFragRef.current.focus();
				break;
			case 'checkVariosFragmentos':
				this.checkNovoCorteRef.current.focus();
				break;
			case 'checkNovosCortes':
				this.checkColoracaoRef.current.focus();
				break;
			case 'coloracao':
				if (value) {
					this.coloracaoRef.current.focus();
				} else {
					this.checkAntigenoRef.current.focus();
				}
				break;
			case 'antigeno':
				if (value) {
					this.antigenoRef.current.focus();
				} else {
					this.materialRef.current.focus();
				}
				break;
			case 'material':
				this.tipoBlocoRef.current.focus();
				break;
			case 'tipoBloco':
				this.tecnicoRef.current.focus();
				break;
			case 'tecnico':
				this.state.medico === null
					? this.medicoRef.current.focus()
					: this.anotacaoRef.current.focus();
				break;
			case 'medico':
				this.anotacaoRef.current.focus();
				break;
			default:
				break;
		}
	}

	updateValorColoracaoDetalhes(value) {
		let coloracoes = [];
		value.forEach(color => {
			if (color.coloracoes) {
				color.coloracoes.forEach(c => {
					coloracoes.push(c);
				});
			} else {
				coloracoes.push(color);
			}
		});
		coloracoes = Array.from(new Set(coloracoes.map(JSON.stringify))).map(
			JSON.parse
		);
		this.updateValorDetalhesState([
			{ name: 'coloracoesId', value: coloracoes },
			{ name: 'coloracao', value: coloracoes.length > 0 }
		]);
	}
	updateValorAntigenoDetalhes(value) {
		this.updateValorDetalhesState([
			{ name: 'antigenosId', value: value },
			{ name: 'antigeno', value: value.length > 0 }
		]);
	}
	updateValorDetalhesState(array) {
		let detalhes = {
			...this.state.detalhesBloco
		};

		array.forEach(item => {
			detalhes = {
				...detalhes,
				[item.name]: item.value
			};
		});

		this.setState({
			detalhesBloco: detalhes
		});
	}

	gravarBloco() {
		const {
			frasco,
			material,
			//medico,
			tecnico,
			tipoBloco,
			coloracao,
			coloracoesSelecionadas,
			tipoDescarte,
			medicoTipoDescarte,
			materialTotalmenteSubmetido
		} = this.state;

		if (
			!materialTotalmenteSubmetido &&
			tipoDescarte.value &&
			!medicoTipoDescarte
		) {
			this.props.commonActions.showAlerta(
				'erro',
				'Com a opção de descarte selecionada é necessário informar o médico solicitante do mesmo.',
				5000,
				'750px'
			);
			return;
		}

		if (
			frasco === null ||
			frasco.length === 0 ||
			material === null ||
			//medico === null ||
			tecnico === null ||
			tipoBloco === null ||
			(coloracao && coloracoesSelecionadas.length === 0)
		) {
			this.props.commonActions.showAlerta(
				'erro',
				'Preencha os campos obrigatórios',
				1500
			);
		} else {
			const blocos = [];

			this.props.blocos.forEach(bloco => {
				blocos.push({
					bloco: bloco.bloco,
					numeroBloco: bloco.numeroBloco,
					fragmentos: this.state.variosFragmentos
						? 0
						: this.state.numeroFragmentos,
					nuOrdem: bloco.nuOrdem
				});
			});

			const mapaMacroscopico = {
				frascoId: this.state.frasco.map(f => f.value),
				materialId: this.state.material.value,
				medicoId: this.state.medico != undefined ? this.state.medico.value : 0,
				tecnicoId: this.state.tecnico.value,
				tipoBloco: this.state.tipoBloco.label,
				anotacao: this.state.anotacoes,
				sentinelaMama: this.state.sentinelaMama,
				sentinelaMelanoma: this.state.sentinelaMelanoma,
				novosCortes: this.state.novoscortes,
				coloracao: this.state.coloracao,
				coloracoesId: this.state.coloracao
					? this.state.coloracoesSelecionadas.map(c => c.id)
					: [],
				antigeno: this.state.antigeno,
				antigenosId: this.state.antigeno
					? this.state.antigenosSelecionados.map(a => a.value)
					: [],
				blocos: blocos,
				materialTotalmenteSubmetido: materialTotalmenteSubmetido,
				tipoDescarte: this.state.tipoDescarte
					? this.state.tipoDescarte.value
					: null,
				medicoTipoDescarteId: this.state.medicoTipoDescarte
					? this.state.medicoTipoDescarte.value
					: null
			};

			WebapiCommon.gravarBlocos(
				this.props.detalhes.laudo,
				mapaMacroscopico
			).then(result => {
				if (result.success) {
					this.props.actions.adicionarBlocosTemporarios([]);
					this.props.actions.adicionarBloco([]);
					this.setState({
						frasco: null,
						material: null,
						//tecnico: null,
						//tipoBloco: null,
						//medicoTipoDescarte: null
						anotacoes: '',
						numeroBlocos: '',
						numeroFragmentos: '',
						sentinelaMama: false,
						sentinelaMelanoma: false,
						novoscortes: false,
						coloracao: false,
						coloracoesSelecionadas: [],
						antigeno: false,
						antigenosSelecionados: [],
						variosFragmentos: false,
						urgente: false,
						tipoDescarte: tiposDescarte.find(
							x => x.value === DefaultValues.tipoDescarteEmum.PADRAO
						),
					});
					this.props.actions.showFadeCarregando(true);
					WebapiCommon.getBlocos(this.props.detalhes.laudo).then(blocos => {
						this.props.actions.adicionarBlocosExistentes(blocos);
						this.props.actions.showFadeCarregando(false);
						this.operacaoAlertaSucesso();
						this.frascoRef.current.focus();
					});
				} else {
					this.props.commonActions.showAlerta('erro', result.message, 1500);
				}
			});
		}
	}

	operacaoAlertaSucesso() {
		this.props.commonActions.showAlerta(
			'sucesso',
			'Operação realizada com sucesso.',
			1500
		);
	}

	onChangeJustificativaCancelamento(texto) {
		this.setState({
			justificativaCancelamento: texto
		});
	}

	removerCasseteParaAgrupamento(id) {
		let agrupamento = [...this.state.agrupamento];
		let index = agrupamento.findIndex(e => e.id === id);

		agrupamento.splice(index, 1);

		this.setState({
			agrupamento: agrupamento
		});
	}

	adicionarCasseteParaAgrupamento(id, nome) {
		let agrupamento = [...this.state.agrupamento];

		agrupamento.push({
			id: id,
			nome: nome
		});

		this.setState({
			agrupamento: agrupamento
		});
	}

	gerarLabelColoracao(coloracoesId) {
		if (this.props.coloracoes.length > 0) {
			var options = this.props.coloracoes[1].options;
			options = options.filter(o => coloracoesId.indexOf(o.id) > -1);

			var label = '';
			options.forEach(o => {
				label += o.label + '\n';
			});
			return label;
		}
	}

	gerarLabelAntigeno(antigenosId) {
		if (this.props.antigenos.length > 0) {
			var antigenos = this.props.antigenos.filter(
				a => antigenosId.indexOf(a.value) > -1
			);
			var label = '';
			antigenos.forEach(a => {
				label += a.label + '\n';
			});
			return label;
		}
	}

	agruparCasseteSelecionado() {
		let blocos = [...this.props.blocosExistentes];
		var ids = [];
		this.state.agrupamento.forEach(bloco => {
			let b = blocos.find(item => item.id === bloco.id);
			if (b) {
				b.numeroBloco += ' ' + this.state.complementoAgrupamento;
			}
			ids.push(b.id);
		});
		WebapiCommon.agruparCassetes(
			ids,
			this.state.complementoAgrupamento,
			this.props.detalhes.laudo
		);

		this.props.actions.adicionarBlocosExistentes(blocos);

		this.setState({
			agrupamento: [],
			complementoAgrupamento: undefined
		});
	}

	onChangeComplementoAgrupamento(ev) {
		this.setState({
			complementoAgrupamento: ev.target.value
		});
	}

	updateValorSentinela(name) {
		this.setState(state => ({
			sentinelaMama: name === 'sentinelaMama' && !state.sentinelaMama,
			sentinelaMelanoma:
				name === 'sentinelaMelanoma' && !state.sentinelaMelanoma
		}));
	}

	updateValorSentinelaModoEdicao(name) {
		let detalhesBloco = { ...this.state.detalhesBloco };
		detalhesBloco.sentinelaMama =
			name === 'sentinelaMama' && !detalhesBloco.sentinelaMama;
		detalhesBloco.sentinelaMelanoma =
			name === 'sentinelaMelanoma' && !detalhesBloco.sentinelaMelanoma;

		this.setState({
			detalhesBloco: detalhesBloco
		});
	}

	toogleModalControleReceptaculo = () => {
		this.setState(state => ({
			modalControleReceptaculo: !state.modalControleReceptaculo
		}));
	};

	marcarMaterialSubmetido(e) {
		if (this.props.detalhes.entregue) {
			return this.props.commonActions.showAlerta(
				'erro',
				'Não é possível alterar o material porque o Exame já foi entregue',
				5000,
				'750px'
			);
		}
		if (e) {
			this.setState({
				materialTotalmenteSubmetido: e,
				tipoDescarte: tiposDescarte.find(
					x => x.value === DefaultValues.tipoDescarteEmum.PADRAO
				)
			});
		} else {
			this.setState({ materialTotalmenteSubmetido: e });
		}
	}
	editarMaterialSubmetido(e) {
		let draft = this.state.detalhesBloco;
		draft.materialTotalmenteSubmetido = e.target.checked;

		if (e) {
			this.setState({
				detalhesBloco: draft,
				tipoDescarte: tiposDescarte.find(
					x => x.value === DefaultValues.tipoDescarteEmum.PADRAO
				)
			});
		} else {
			this.setState({ detalhesBloco: draft });
		}
	}

	obterNumeroBloco(bloco) {
		const reg = new RegExp(`${bloco.nuOrdem}$`);
		let { cassetesNumeracaoContinua } = this.state;
		let { blocosExistentes, blocos } = this.props;
		let numeroBloco = bloco.numeroBloco;

		if (bloco.isDoisFrascosUmCassete && !cassetesNumeracaoContinua) {
			let cassetesFromDoisFrascos = blocosExistentes.filter(
				el => el.isDoisFrascosUmCassete
			);

			numeroBloco =
				cassetesFromDoisFrascos.length === 1 &&
					blocos.filter(el => el.isDoisFrascos).length === 0
					? bloco.numeroBloco.trimEnd().replace(reg, '')
					: bloco.numeroBloco;
		} else {
			let cassetesNormais = blocosExistentes.filter(
				el => !el.isDoisFrascosUmCassete
			);
			numeroBloco = cassetesNumeracaoContinua
				? bloco.numeroBloco
				: cassetesNormais.filter(
					el =>
						el.frascoOrigem === bloco.frascoOrigem &&
						el.isNovoCorte === bloco.isNovoCorte
				).length === 1 &&
					blocos.filter(
						el =>
							el.frascoId === bloco.frascoOrigem &&
							el.isNovoCorte === bloco.isNovoCorte
					).length === 0
					? bloco.numeroBloco.trimEnd().replace(reg, '')
					: bloco.numeroBloco;
		}

		return numeroBloco;
	}

	toogleModalJustificativaReabertura = () =>
		this.setState(state => ({
			showModalJustificativaReabertura: !state.showModalJustificativaReabertura
		}));

	changeTextoJustificativaReabertura = e =>
		this.setState({ textoJustificativaReabertura: e.currentTarget.value });

	numeroFragmentosKeyPress(ev) {
		if (ev.key === 'Enter' && ev.target.value === '0') {
			this.setState({ variosFragmentos: true });
		}
	}
}

const mapStateToProps = state => {
	return {
		usuario: state.usuario,
		frascos: state.macroscopia.frascos,
		detalhes: state.commonReducer.detalhes,
		material: state.macroscopia.material,
		tipo: state.macroscopia.tipo,
		coloracoes: state.commonReducer.coloracoes,
		antigenos: state.commonReducer.antigenos,
		medicoTecnico: state.macroscopia.medicoTecnico,
		medicoMacroscopista: state.macroscopia.medicoMacroscopista,
		blocos: state.macroscopia.blocos,
		blocosNovos: state.macroscopia.blocosNovos,
		blocosExistentes: state.macroscopia.blocosExistentes,
		medicoPadraoMacroscopia: state.commonReducer.medicoPadraoMacroscopia,
		listagem: state.commonReducer.listagem,
		imprimirControleCassetesAoFinalizarMapa:
			state.macroscopia.imprimirControleCassetesAoFinalizarMapa
	};
};

const mapsDispacthToProps = dispatch => {
	return {
		actions: bindActionCreators(actions, dispatch),
		commonActions: bindActionCreators(commonActions, dispatch)
	};
};

export default connect(
	mapStateToProps,
	mapsDispacthToProps
)(GeracaoBlocosContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/blocos/gerar-blocos.container.js